import { Box, Typography } from '@mui/material';

type GridCurrencyCellProps = {
  totalPremium: number | undefined;
};

export const GridCurrencyCell = (props: GridCurrencyCellProps) => {
  const { totalPremium } = props;
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        minWidth: '90px',
      }}
    >
      <Typography
        variant='bodySmall'
        sx={{
          color: (theme) => (theme.palette.theme === 'lio' ? 'common.black' : 'font.main'),
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        $
        {totalPremium?.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </Typography>
    </Box>
  );
};
